export default {"src":"/_next/static/image/public/images/ic_hp_share_icon.e0418867d3ec2e1e6ad1e21a46d9e667.svg","height":17,"width":17};